<template>
  <div>
    <div class="pa-1">
      <v-card>
        <v-card-title>{{ $t('Purchase by Time') }}</v-card-title>
        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <template v-if="purchaseByTimeSeries">
          <apexchart
            ref="purchaseByTime"
            type="area"
            height="350"
            :options="purchaseByTime"
            :series="purchaseByTimeSeries"
          ></apexchart>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'

export default {
  props: ['selectedDate', 'filter'],
  data: function () {
    return {
      loading: false,
      purchaseByTimeSeries: undefined,
      purchaseByTime: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23'
          ]
        },
        yaxis: {
          title: {
            text: 'Purchase'
          },
          tickAmount: 1,
          labels: {
            formatter: function (val, index) {
              return val.toFixed(0)
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' Purchases'
            }
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function () {
    this.getPurchaseByTime()
  },
  methods: {
    getPurchaseByTime() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid, // required
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
      }
      vm.loading = true
      api.getLamyOverview2PurchaseByTime(data, (err, response) => {
        if (response.responsecode == 200) {
          let data = []
          let label = []

          $.each(response.data[0], function (index, val) {
            label.push(index.split('_')[1] + ':00')
            data.push(parseInt(val))
          })

          vm.purchaseByTimeSeries = [{ name: '', data: data }]
          vm.$emit('dataPurchaseTime', response.data[0])

          vm.$nextTick(function () {
            if (vm.$refs.purchaseByTime) {
              vm.$refs.purchaseByTime.updateOptions({
                xaxis: {
                  categories: label,
                  labels: {
                    show: true
                  }
                }
              })
            }
          })

          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getPurchaseByTime()
      },
      deep: true
    },
    filter: function () {
      this.getPurchaseByTime()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/PurchaseByTime.vue